import React from 'react'
import { ToggleButton, Tooltip, Typography } from '@mui/material'
import { IOlexName } from 'src/generated-types/olex-match'
import { PanelCard, PanelHeader, SectionLabel, Segmented } from './ExpandGrid.style'
import { CountChip } from './PublishMooring.style'
import { OLEX_MATCH_TYPES, isOlexNameUsable } from './olexMatch.action'

interface OlexNameChoiceProps {
  names: IOlexName[]
  useOlexNames: boolean
  onUseOlexNamesChange: (value: boolean) => void
  t: (key: string, options?: object) => string
}

// Keep the names, or rename to the file's names where they are free. The pairs per type are in the tooltips.
const OlexNameChoice: React.FC<OlexNameChoiceProps> = ({ names, useOlexNames, onUseOlexNamesChange, t }) => {
  const usable = names.filter(n => isOlexNameUsable(n.issue)).length
  const pairs = (list: IOlexName[]) =>
    list
      .slice(0, 20)
      .map(n => `${n.name} → ${n.olexName}`)
      .join('\n')
  const groups = OLEX_MATCH_TYPES.map(item => ({ ...item, names: names.filter(n => n.type === item.type) })).filter(
    group => group.names.length > 0,
  )

  return (
    <PanelCard>
      <PanelHeader>
        <SectionLabel>{t('revision-olex-names-title')}</SectionLabel>
        <CountChip>{names.length}</CountChip>
      </PanelHeader>
      <Segmented
        size="small"
        exclusive
        value={useOlexNames ? 'olex' : 'existing'}
        onChange={(_, value: string | null) => value && onUseOlexNamesChange(value === 'olex')}
      >
        <ToggleButton value="existing">{t('revision-olex-names-existing')}</ToggleButton>
        <ToggleButton value="olex" disabled={usable === 0}>
          {t('revision-olex-names-olex')}
        </ToggleButton>
      </Segmented>
      <Typography fontSize={12} color="text.secondary">
        {groups.map((group, index) => (
          <React.Fragment key={group.type}>
            {index > 0 && ' · '}
            <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{pairs(group.names)}</span>}>
              <span style={{ textTransform: 'capitalize', cursor: 'default' }}>
                {t(group.key)} {group.names.length}
              </span>
            </Tooltip>
          </React.Fragment>
        ))}
      </Typography>
    </PanelCard>
  )
}

export default OlexNameChoice
